import api from '@/lib/api';

export const BINDINGS_LOAD = 'BINDINGS_LOAD';
export const BINDING_CREATE = 'BINDING_CREATE';
export const BINDING_DELETE = 'BINDING_DELETE';
export const MESSAGE_SEND = 'MESSAGE_SEND';
const BINDINGS_CHANGE = 'BINDINGS_CHANGE';
const BINDINGS_LOADING_CHANGE = 'BINDINGS_LOADING_CHANGE';
const BINDINGS_SAVING_CHANGE = 'BINDINGS_SAVING_CHANGE';
const BINDINGS_ERRORS_CHANGE = 'BINDINGS_ERRORS_CHANGE';
const MESSAGE_SENDING_CHANGE = 'MESSAGE_SENDING_CHANGE';
const MESSAGE_ERRORS_CHANGE = 'MESSAGE_ERRORS_CHANGE';

const state = {
  bindings: [],
  bindings_loading: false,
  bindings_saving: false,
  bindings_errors: {},
  message_sending: false,
  message_errors: {},
};

const actions = {
  /**
   * Загружает привязки ботов для ассистента
   * @param commit
   * @param state
   * @param {Object} param - Параметры
   * @param {string} param.assistant_id - ID ассистента
   * @param {string} param.channel - Канал (telegram, etc.)
   * @param {Object} [param.options] - Дополнительные опции
   */
  [BINDINGS_LOAD]({ commit, state }, param) {
    const assistant_id = param.assistant_id;
    const channel = param.channel || 'telegram';
    const options = param.options || {};

    return api.load(
      'chatbot.bindings.list',
      channel,
      state,
      commit,
      BINDINGS_LOADING_CHANGE,
      BINDINGS_CHANGE,
      BINDINGS_ERRORS_CHANGE,
      {
        ...options,
        params: { assistant_id },
      },
    );
  },

  /**
   * Создает привязку бота
   * @param commit
   * @param state
   * @param {Object} param - Параметры
   * @param {Object} param.model - Данные привязки
   * @param {string} param.channel - Канал (telegram, etc.)
   * @param {Object} [param.options] - Дополнительные опции
   */
  [BINDING_CREATE]({ commit, state }, param) {
    const model = param.model;
    const channel = param.channel || 'telegram';
    const options = param.options || {};

    return api.create(
      'chatbot.bindings.create',
      channel,
      model,
      state,
      commit,
      BINDINGS_SAVING_CHANGE,
      BINDINGS_CHANGE,
      BINDINGS_ERRORS_CHANGE,
      options,
    );
  },

  /**
   * Удаляет привязку бота
   * @param commit
   * @param state
   * @param {Object} param - Параметры
   * @param {string} param.id - ID привязки
   * @param {string} param.channel - Канал (telegram, etc.)
   * @param {Object} [param.options] - Дополнительные опции
   */
  [BINDING_DELETE]({ commit, state }, param) {
    const id = param.id;
    const channel = param.channel || 'telegram';
    const options = param.options || {};

    return api.delete(
      'chatbot.bindings.delete',
      [channel, id],
      state,
      commit,
      BINDINGS_CHANGE,
      options,
    );
  },

  /**
   * Отправляет тестовое сообщение
   * @param commit
   * @param state
   * @param {Object} param - Параметры
   * @param {Object} param.model - Данные сообщения
   * @param {Object} [param.options] - Дополнительные опции
   */
  [MESSAGE_SEND]({ commit, state }, param) {
    const model = param.model;
    const options = param.options || {};

    return api.create(
      'chatbot.message.send',
      '',
      model,
      state,
      commit,
      MESSAGE_SENDING_CHANGE,
      null,
      MESSAGE_ERRORS_CHANGE,
      options,
    );
  },
};

const mutations = {
  [BINDINGS_CHANGE](state, data) {
    // Проверяем, что data является массивом
    if (Array.isArray(data)) {
      state.bindings = Object.freeze(data.map((item) => Object.freeze(item)));
    } else if (data && Array.isArray(data.data)) {
      // Если данные пришли в формате { data: [...] }
      state.bindings = Object.freeze(data.data.map((item) => Object.freeze(item)));
    } else {
      // Если данные не в ожидаемом формате, устанавливаем пустой массив
      state.bindings = Object.freeze([]);
    }
  },

  [BINDINGS_LOADING_CHANGE](state, data) {
    state.bindings_loading = data;
  },

  [BINDINGS_SAVING_CHANGE](state, data) {
    state.bindings_saving = data;
  },

  [BINDINGS_ERRORS_CHANGE](state, data) {
    state.bindings_errors = data;
  },

  [MESSAGE_SENDING_CHANGE](state, data) {
    state.message_sending = data;
  },

  [MESSAGE_ERRORS_CHANGE](state, data) {
    state.message_errors = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
